import AllowAccess from './AllowAccess'

export default AllowAccess
